import { TaggingTypeEnum } from '../../../enums';

import { MutationClass, TaggingActionData, TaggingState, TaggingViewData } from '../../../models';

export class DataMutation implements MutationClass {

  public static execute(state: TaggingState, payload: { data: TaggingViewData | TaggingActionData, type: TaggingTypeEnum }): void {
    ({
      [TaggingTypeEnum.VIEW]: () => state.data[TaggingTypeEnum.VIEW] = payload.data as TaggingViewData,
      [TaggingTypeEnum.ACTION]: () => state.data[TaggingTypeEnum.ACTION] = payload.data as TaggingActionData
    }[payload.type])();
  }

}
